import { render, staticRenderFns } from "./VaultTransferToCBN.vue?vue&type=template&id=53ff1ccc&"
import script from "./VaultTransferToCBN.vue?vue&type=script&lang=js&"
export * from "./VaultTransferToCBN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports